import type { CardProps } from "./Card.types";

export const Card = ({ children, header, footer, className }: CardProps) => {
  return (
    <div className={className}>
      {header && <div>{header}</div>}
      <div>{children}</div>
      {footer && <div>{footer}</div>}
    </div>
  );
};
